import styled, { css } from 'styled-components';
import { SortDirection } from 'src/lib/tanstack-react-table';
import { hexToRgba } from 'src/utils';
import { SortIcon } from 'src/assets/icons';
import { IconButton } from '../../../atoms';

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    // no text wrap
    white-space: nowrap;
  }
`;

interface StyledSortIconProps {
  $isSorted: false | SortDirection;
}
export const StyledSortIcon = styled(SortIcon)<StyledSortIconProps>`
  path {
    transform: scale(0.36) translate(18px, 44px);
    fill: ${({ theme }) => theme.colors.grey2};

    ${({ $isSorted }) => {
      switch (true) {
        case $isSorted === 'asc':
          return css`
            &:first-child {
              fill: ${({ theme }) => theme.colors.primaryDark};
            }
          `;
        case $isSorted === 'desc':
          return css`
            &:last-child {
              fill: ${({ theme }) => theme.colors.primaryDark};
            }
          `;

        default:
          return '';
      }
    }};
  }
`;

export const StyledIconButton = styled(IconButton)<StyledSortIconProps>`
  margin-left: 16px;

  background-color: ${({ $isSorted, theme }) => ($isSorted ? hexToRgba(theme.colors.primary, 0.1) : '')};

  &:hover {
    background-color: ${({ $isSorted, theme }) =>
      $isSorted ? hexToRgba(theme.colors.primary, 0.1) : theme.colors.borderColor} !important;
  }
`;
